// extracted by mini-css-extract-plugin
export var actionText = "_ml-4";
export var container = "_ml-0";
export var leftSection = "_ml-1";
export var rightSection = "_ml-2";
export var settingsButton = "_ml-6";
export var settingsIcon = "_ml-7";
export var shortcut = "_ml-5";
export var shortcutGroup = "_ml-3";